import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Drawer, Grid, Typography, Chip, makeStyles, Button, Divider } from "@material-ui/core";
import _ from "lodash";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import LocationOffIcon from "@material-ui/icons/LocationOff";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import TodayIcon from "@material-ui/icons/Today";
import AddIcon from "@material-ui/icons/Add";
import PersonIcon from "@material-ui/icons/Person";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    drawerContainer: {
      padding: "24px",
      width: "380px"
    },
    chipGroup: {
      borderRadius: "6px",
      background: theme.palette.background.paper,
      margin: "4px",
      border: "1px solid ".concat(theme.palette.text.primary)
    },
    attended: {
      border: "1px solid ".concat(theme.palette.primary.main),
      color: theme.palette.primary.main
    },
    not_attended: {
      border: "1px solid ".concat(theme.palette.secondary.main),
      color: theme.palette.secondary.main
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    },
    textIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    },
    textIconPointer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      cursor: "pointer"
    },
    textIconHorizontal: {
      marginTop: "8px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    pointer: {
      cursor: "pointer"
    },
    title: {
      margin: "16px 0 8px 0"
    },
    card: {
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px 0"
    },
    cardText: {
      marginTop: "8px"
    },
    cardIconText: {
      marginTop: "8px",
      display: "flex",
      alignItems: "center"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "24px"
    },
    mr30: {
      marginRight: "30px"
    },
    icon: {
      margin: "8px"
    },
    mt8: {
      marginTop: "8px"
    },
    divider: {
      margin: "4px 0"
    },
    containerDelete: {
      height: "100vh",
      display: "flex",
      alignItems: "center"
    },
    alignCenter: {
      width: "100%",
      textAlign: "center"
    },
    iconDelete: {
      fontSize: "128px",
      textAlign: "center",
      width: "100%"
    },
    iconUser: {
      fontSize: "80px",
      textAlign: "center",
      width: "100%"
    },
    iconActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});

var CampusGroupSingleDrawerAttendance = function CampusGroupSingleDrawerAttendance(props) {
  var _useState = useState("view"),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  var _useState3 = useState("checkin"),
      _useState4 = _slicedToArray(_useState3, 2),
      option = _useState4[0],
      setOption = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      userSelected = _useState6[0],
      setUserSelected = _useState6[1];

  var classes = useStyles(); // console.log("attendance drawer selected", props.attendance);

  var toggleDrawer = function toggleDrawer() {
    setType("view");
    props.toggleDrawer();
  };

  var toggleViewDrawer = function toggleViewDrawer() {
    setType("view");
  };

  var handleSelectUser = function handleSelectUser(key) {
    var auxUserSelected = props.attendance ? props.attendance.attendance ? props.attendance.attendance.find(function (user) {
      return user.key === key;
    }) : null : null;

    if (auxUserSelected) {
      setUserSelected(auxUserSelected);
      setType("view_user");
    }
  };

  var setChildrenAttendance = function setChildrenAttendance() {
    var contentAttendance;

    switch (option) {
      case "checkin":
        contentAttendance = props.attendance ? props.attendance.attendance ? props.attendance.attendance.sort(function (user1, user2) {
          return user1.name.localeCompare(user2.name);
        }).map(function (user) {
          var contentIcon;

          switch (user.status) {
            //ASISTE
            case "attended":
              //HACE CHECKIN
              if (user.checkin) {
                contentIcon = /*#__PURE__*/React.createElement(DoneAllIcon, {
                  color: "primary"
                });
              } // NO TIENE PROPIEDAD CHECKIN
              else {
                  contentIcon = /*#__PURE__*/React.createElement(DoneAllIcon, {
                    style: {
                      color: "#ffe082"
                    }
                  });
                }

              break;
            //NO ASISTE

            case "not_attended":
              contentIcon = /*#__PURE__*/React.createElement(DoneAllIcon, {
                color: "secondary"
              });
              break;
            //LESIONAD@

            case "injured":
              contentIcon = /*#__PURE__*/React.createElement(AddIcon, {
                color: "secondary"
              });
              break;
            //DEMAS CASOS
            // - yes
            // - no

            default:
              contentIcon = /*#__PURE__*/React.createElement(DoneAllIcon, {
                style: {
                  color: "#ffe082"
                }
              });
              break;
          }

          return /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 3,
            className: classes.pointer,
            onClick: function onClick() {
              return handleSelectUser(user.key);
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.textIcon
          }, contentIcon, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, user.name)));
        }) : [] : [];
        break;

      case "checkout":
        contentAttendance = props.attendance ? props.attendance.attendance ? props.attendance.attendance.sort(function (user1, user2) {
          return user1.name > user2.name;
        }).map(function (user) {
          var contentIcon;

          switch (user.status) {
            //ASISTE
            case "attended":
              //HACE CHECKOUT
              if (user.checkout) {
                contentIcon = /*#__PURE__*/React.createElement(DoneAllIcon, {
                  color: "primary"
                });
              } // NO TIENE PROPIEDAD CHECKIN
              else {
                  contentIcon = /*#__PURE__*/React.createElement(DoneAllIcon, {
                    style: {
                      color: "#ffe082"
                    }
                  });
                }

              break;
            //NO ASISTE

            case "not_attended":
              contentIcon = /*#__PURE__*/React.createElement(DoneAllIcon, {
                color: "secondary"
              });
              break;
            //LESIONAD@

            case "injured":
              contentIcon = /*#__PURE__*/React.createElement(AddIcon, {
                color: "secondary"
              });
              break;
            //DEMAS CASOS
            // - yes
            // - no

            default:
              contentIcon = /*#__PURE__*/React.createElement(DoneAllIcon, {
                style: {
                  color: "#ffe082"
                }
              });
              break;
          }

          return /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: 3,
            className: classes.pointer,
            onClick: function onClick() {
              return handleSelectUser(user.key);
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.textIcon
          }, contentIcon, /*#__PURE__*/React.createElement(Typography, {
            variant: "caption"
          }, user.name)));
        }) : [] : [];
        break;

      default:
        break;
    }

    return contentAttendance;
  };

  var renderDrawerContent = function renderDrawerContent() {
    var content;

    switch (type) {
      case "view":
        content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5"
        }, props.attendance ? props.attendance.date || "" : "")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 4
        }), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 4
        }, /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
          value: props.attendance ? props.attendance.percentage || 0 : 0,
          styles: {
            // Customize the root svg element
            root: {},
            // Customize the path, i.e. the "completed progress"
            path: {
              // Path color
              stroke: "rgba(119, 255, 181, ".concat(props.attendance ? props.attendance.percentage || 0 : 0 / 100, ")"),
              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
              strokeLinecap: "butt",
              // Customize transition animation
              transition: "stroke-dashoffset 0.5s ease 0s",
              // Rotate the path
              transformOrigin: "center center"
            },
            // Customize the circle behind the path, i.e. the "total progress"
            trail: {
              // Trail color
              stroke: "#d6d6d6",
              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
              strokeLinecap: "butt",
              // Rotate the trail
              transformOrigin: "center center"
            },
            // Customize the text
            text: {
              // Text color
              fill: "#f88",
              // Text size
              fontSize: "16px"
            },
            // Customize background - only used when the `background` prop is true
            background: {
              fill: "#3e98c7"
            }
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, "".concat(props.attendance ? props.attendance.percentage.toFixed(1) || 0 : 0, "%")))), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 4
        }), props.attendance && props.attendance.comments && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.texts ? props.translation.texts.comments || "Comments" : "Comments" : "Comments")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.attendance ? props.attendance.comments || props.translation ? props.translation.texts ? props.translation.texts.comments_empty || "Empty" : "Empty" : "Empty" : props.translation ? props.translation.texts ? props.translation.texts.comments_empty || "Empty" : "Empty" : "Empty"))), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        }), /*#__PURE__*/React.createElement(Grid, {
          container: true
        }, /*#__PURE__*/React.createElement(Grid, {
          xs: 6
        }, /*#__PURE__*/React.createElement("div", {
          onClick: function onClick() {
            return setOption("checkin");
          },
          className: classes.textIconPointer
        }, /*#__PURE__*/React.createElement(AddLocationIcon, {
          color: option === "checkin" ? "primary" : "inherit"
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          color: option === "checkin" ? "primary" : "inherit"
        }, props.translation ? props.translation.texts ? props.translation.texts.checkin || "Check in" : "Check in" : "Check in"))), /*#__PURE__*/React.createElement(Grid, {
          xs: 6
        }, /*#__PURE__*/React.createElement("div", {
          onClick: function onClick() {
            return setOption("checkout");
          },
          className: classes.textIconPointer
        }, /*#__PURE__*/React.createElement(LocationOffIcon, {
          color: option === "checkout" ? "secondary" : "inherit"
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          color: option === "checkout" ? "secondary" : "inherit"
        }, props.translation ? props.translation.texts ? props.translation.texts.checkout || "Check out" : "Check out" : "Check out"))))), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Grid, {
          container: true
        }, setChildrenAttendance())));
        break;

      case "view_user":
        content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Grid, {
          container: true
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 8
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5"
        }, userSelected ? userSelected.name || "" : ""), /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.attendance ? props.attendance.date || "" : "")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 4
        }, /*#__PURE__*/React.createElement(Chip, {
          label: userSelected.status === "attended" ? props.translation ? props.translation.status ? props.translation.status.attended || "Attended" : "Attended" : "Attended" : props.translation ? props.translation.status ? props.translation.status.not_attended || "Not attended" : "Not attended" : "Not attended",
          className: [classes.chipGroup, userSelected.status === "attended" ? classes.attended : classes.not_attended].join(" ")
        }))), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.mt8
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.checkin || "Check in" : "Check in" : "Check in")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, userSelected.checkin ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.textIconHorizontal
        }, /*#__PURE__*/React.createElement(TodayIcon, {
          className: classes.mr30
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, userSelected.checkin.date ? moment(userSelected.checkin.date).format("DD/MM/YYYY HH:mm") || "Invalid date" : "Invalid date")), userSelected.checkin.responsible && userSelected.checkin.responsible.name && /*#__PURE__*/React.createElement("div", {
          className: classes.textIconHorizontal
        }, /*#__PURE__*/React.createElement(PersonIcon, {
          className: classes.mr30
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, userSelected.checkin.responsible ? userSelected.checkin.responsible.name || "Empty" : "Empty"))) : /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.texts ? props.translation.texts.checkin_empty || "Empty" : "Empty" : "Empty")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.mt8
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.checkout || "Check out" : "Check out" : "Check out")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, userSelected.checkout ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: classes.textIconHorizontal
        }, /*#__PURE__*/React.createElement(TodayIcon, {
          className: classes.mr30
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, userSelected.checkout.date ? moment(userSelected.checkout.date).format("DD/MM/YYYY HH:mm") || "Invalid date" : "Invalid date")), userSelected.checkout.responsible && userSelected.checkout.responsible.name && /*#__PURE__*/React.createElement("div", {
          className: classes.textIconHorizontal
        }, /*#__PURE__*/React.createElement(PersonIcon, {
          className: classes.mr30
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, userSelected.checkout.responsible ? userSelected.checkout.responsible.name || "Empty" : "Empty"))) : /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.texts ? props.translation.texts.checkout_empty || "Empty" : "Empty" : "Empty")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.alignCenter
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "secondary",
          onClick: function onClick() {
            return setType("view");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.back || "Back" : "Back" : "Back")));
        break;

      default:
        content = "";
        break;
    }

    return content;
  };

  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: props.open,
    onClose: type === "view" ? toggleDrawer : toggleViewDrawer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.drawerContainer,
    spacing: 2
  }, renderDrawerContent()));
};

export { CampusGroupSingleDrawerAttendance };